<template>
<div class="container">
  <div class="center">

    <div class="menu-wrap">
      <div class="icon-menu" v-for="(item, index) in menuInfo2" @click="clickMenu(item.permission, item.title)">
        <div class="title">
          {{item.title}}
        </div>
        <div class="img-wrap" :style="{'background-color':item.bkColor}">
          <div class="top"></div>
          <img :src=item.imgUrl />
        </div>
      </div>

      <div style="clear: both; width: 49%;"></div>
    </div>

    <div class="footer-margin">
    </div>

  </div>
</div> <!--container结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default {
    data() {
      return {
        'noData':true,
        permission:{},
        menuInfo:[
          {
            title:'EasyPatch',
            bkColor:'#0c544f',
            imgUrl:"/static/accountadmin/icon_easypatch.png",
            permission:'EasyPatchLogin',
          },
          {
            title:'EasyUpdate',
            bkColor:'#0c544f',
            imgUrl:"/static/accountadmin/icon_easypatch.png",
            permission:'EasyUpdateLogin'
          },
          {
            title:'HCP',
            bkColor:'#335ea8',
            imgUrl:"/static/accountadmin/icon_hcp.png",
            permission:'HCPCreate'
          },
          {
            title:'Software Upgrade',
            bkColor:'#ee7c58',
            imgUrl:"/static/accountadmin/icon_software.png",
            permission:'FirmwareUpdateConfig'
          },
          {
            title:'HCL function -PDM',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/icon_hcl_pdm.png",
            permission:'HCLConfig'
          },
          {
            title:'HCL function -EasyPatch',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/icon_hcl_easypatch.png",
            permission:'HCLConfigForEasyPatch'
          },
           {
            title:'DataExport',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/download.png",
            permission:'DataExport'
          },
          {
            title:'FileUpload',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/fileupload.png",
            permission:'FileUpload'
          },
          {
            title:'Data statistics',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/icon_hcl.png",
            permission:'HCLStatistics'
          },
           {
            title:'User',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/icon_user@2x.png",
            permission:'UserAdmin'
          },
          {
            title:'DevDebug',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/explain.png",
            permission:'DevDebug'
          },
          {
            title:'Member',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/icon_member.png",
            permission:'Agency'
          },
          {
            title:'History',
            bkColor:'#5b7f70',
            imgUrl:"/static/accountadmin/icon_history.png",
            permission:'History'
          },
        ],
        menuInfo2:[

        ]
      }
    },
    computed:{

    },
    watch:{

    },
    mounted(){
      this.loadData()
    },
    methods: {
      loadData() {
        let permission = JSON.parse(sessionStorage.getItem('account_admin_permission'))
        let role =sessionStorage.getItem('role')
        let permissionFlag={};
        let menuInfo=[];
        permission.map(function (e,i) {
          permissionFlag[e] = true;
        })
        if(role!=='AgencyAccountAdmin'){
          permissionFlag.History =true
        }
        
        this.menuInfo.map(function (e,i) {
          if (permissionFlag[e.permission]) {
            menuInfo.push(e)
          }
        })
        this.permission = permissionFlag;
        
        // this.permission.push('History')
        this.menuInfo2 = menuInfo;
      },
      addAccount() {

      },
      deleteAccount() {

      },
      clickMenu(permission, title) {
        sessionStorage.setItem('account_admin_permission_value', permission)
        sessionStorage.setItem('account_admin_permission_title', title)
        if ('HCPCreate'==permission) {
          this.$router.push('/CreateHCP_list');
        } else if ('HCLStatistics'==permission){
          this.$router.push('/dataStatistics')
        }  else if ('UserAdmin'==permission){
          this.$router.push('/UserAdmin')
        }else if ('DevDebug'==permission){
          this.$router.push('/DevDebug')
        }else if ('Agency'==permission){
          this.$router.push('/Member')
        }else if ('History'==permission){
          this.$router.push('/History')
        }else {
          this.$router.push('/accountsadmin_list')
        }
      }
    },
  }
</script>

<style scoped>
  .container {
    min-height:100%;
    background-color:#ffffff;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .menu-wrap {
    width: 70%;
    margin: 0 auto;
    padding-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .menu-wrap .icon-menu {
    width: 49%;
    float: left;
    cursor: pointer;
  }

  .menu-wrap .icon-menu:nth-child(n+3) {
    margin-top:30px;

  }

  .menu-wrap .icon-menu .title {
    border-left: 2px solid #0c544f;
    padding-left: 10px;
  }

  .menu-wrap .icon-menu .img-wrap {
    width:180px;
    height:90px;
    *background-color:#0c544f;
    border-radius:4px;
    box-shadow:5px 5px 10px rgba(0, 0, 0, 0.16);
    margin-top:20px;
    *padding-top: 15px;
  }

  .menu-wrap .icon-menu .img-wrap .top {
    height: 1px;
  }

  .menu-wrap .icon-menu .img-wrap img {
    display: block;
    height:60px;
    width: 60px;
    margin: 0 auto;
    margin-top:13px;
  }

  .footer-margin {
    height:80px;
  }
</style>



// WEBPACK FOOTER //
// AccountAdminHome.vue?dddd31c2